import {
  deleteProduct,
  getProducts,
  updateProductStatus,
  type ProductsResponse,
} from "@/infrastructure/services/productService";
import { useCallback, useState } from "react";

const emptyProducts: ProductsResponse = {
  produtos_cadastrados: 0,
  visiveis_vitrine: 0,
  nao_publicados: 0,
  produtos: [],
};

export function useProducts() {
  const [productsData, setProductsData] = useState(emptyProducts);
  const [isLoading, setIsLoading] = useState(false);
  const [isMutating, setIsMutating] = useState(false);
  const [error, setError] = useState("");
  const loadProducts = useCallback(async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await getProducts();
      setProductsData(data);
      return data;
    } catch (requestError) {
      const message =
        requestError instanceof Error
          ? requestError.message
          : "Não foi possível carregar os produtos.";
      setError(message);
      setProductsData(emptyProducts);
      throw requestError;
    } finally {
      setIsLoading(false);
    }
  }, []);
  const removeProduct = useCallback(async (id: number) => {
    setIsMutating(true);
    try {
      await deleteProduct(id);
    } finally {
      setIsMutating(false);
    }
  }, []);
  const changeProductStatus = useCallback(
    async (id: number, status: "PUBLICADO" | "OCULTO") => {
      setIsMutating(true);
      try {
        await updateProductStatus(id, status);
      } finally {
        setIsMutating(false);
      }
    },
    [],
  );
  return {
    changeProductStatus,
    error,
    isLoading,
    isMutating,
    loadProducts,
    productsData,
    removeProduct,
  };
}
